<section class="account">

  <form class="widget account__form" data-id="password-form" novalidate autocomplete="on">
    <div class="widget__head">
      <h3 class="widget__title"><i class="icon icon--key-round"></i> <%= _lcs( 'Passwort ändern' ) %></h3>
    </div>

    <div class="widget__body account__fields">
      <!-- Lets password managers file the new password under the right account. -->
      <input type="email" name="username" autocomplete="username" value="<%= email %>" hidden />

      <div class="field">
        <label class="field__label" for="pw-current"><%= _lcs( 'Aktuelles Passwort' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--lock"></i></span>
          <input class="field__input" id="pw-current" name="currentPassword" type="password"
                 autocomplete="current-password" required />
          <button class="field__toggle" type="button" data-toggle="pw-current"
                  aria-label="<%= _lcs( 'Passwort anzeigen' ) %>" aria-pressed="false">
            <i class="icon icon--eye"></i>
          </button>
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="pw-new"><%= _lcs( 'Neues Passwort' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--key-round"></i></span>
          <input class="field__input" id="pw-new" name="newPassword" type="password"
                 autocomplete="new-password" minlength="<%= minLength %>" required />
          <button class="field__toggle" type="button" data-toggle="pw-new"
                  aria-label="<%= _lcs( 'Passwort anzeigen' ) %>" aria-pressed="false">
            <i class="icon icon--eye"></i>
          </button>
        </div>
        <span class="account__help"><%= _lcs( 'Mindestens {count} Zeichen.', { count: minLength } ) %></span>
      </div>

      <div class="field">
        <label class="field__label" for="pw-repeat"><%= _lcs( 'Neues Passwort wiederholen' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--key-round"></i></span>
          <input class="field__input" id="pw-repeat" name="repeatPassword" type="password"
                 autocomplete="new-password" required />
          <button class="field__toggle" type="button" data-toggle="pw-repeat"
                  aria-label="<%= _lcs( 'Passwort anzeigen' ) %>" aria-pressed="false">
            <i class="icon icon--eye"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="account__form-foot">
      <p class="account__hint"><%= _lcs( 'Bestehende Anmeldungen bleiben aktiv.' ) %></p>
      <button type="submit" class="btn btn--primary btn--sm">
        <i class="icon icon--check"></i> <%= _lcs( 'Passwort ändern' ) %>
      </button>
    </div>
  </form>

</section>
